export default __webpack_public_path__ + "static/media/eliqx-banner-hp-mobile-10-2021.ee12ccfb.jpg";